<template>
  <extensions-permission-guard :situation-id="situationId">
    <DataLoader v-if="fetchLoading" :loading="fetchLoading" />
    <template v-else>
      <product-form-layout
        :product-images.sync="productImages"
        :product="product"
      />
      <v-btn
        class="px-10 my-2 text-body-2 float-right"
        color="primary darken-1"
        min-height="50px"
        min-width="100px"
        tile
        dark
        depressed
        @click="updateProduct"
      >
        保存
      </v-btn>
    </template>
  </extensions-permission-guard>
</template>

<script>
import ExtensionsPermissionGuard from '@/components/commons/ExtensionsPermissionGuard'
import { PRODUCTS_SITUATION_ID } from '@/mixins/site_permission_utils'
import DataLoader from '@/components/commons/DataLoader'
import {
  upload as uploadImage,
  update as updateImage,
  _delete as deleteImage
} from './api/productImages'
import ProductFormLayout from '@/components/commons/products/ProductFormLayout'
import axios from 'axios'
import { deserialize } from 'deserialize-json-api'
import headUtilsMixin from '@/mixins/head_utils'

export default {
  components: {
    ProductFormLayout,
    DataLoader,
    ExtensionsPermissionGuard
  },
  mixins: [headUtilsMixin],
  data () {
    return {
      pageTitle: '商品編集',
      situationId: PRODUCTS_SITUATION_ID,
      taxIncludedSelectItems: [
        { text: '税込', value: true },
        { text: '税抜', value: false }
      ],
      productId: this.$route.params.id,
      product: {
        name: '',
        price: null,
        description: '',
        isTaxIncluded: null,
        productLinksAttributes: [
          {
            productLinkStyleId: null,
            linkText: '',
            price: null,
            isTaxIncluded: null,
            url: '',
            priority: 0
          }
        ]
      },
      productImages: [],
      fetchLoading: true
    }
  },
  async mounted () {
    this.fetchLoading = true
    await this.fetchProduct()
    this.fetchLoading = false
  },
  methods: {
    fetchProduct () {
      return axios
        .get(`/api/products/${this.productId}`)
        .then(({ data }) => {
          this.product = deserialize(data).data
          this.productImages.splice(0, this.productImages.length)
          this.productImages.push(...(this.product.productImages || []))
        })
        .catch((error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.message
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        })
    },
    updateProduct () {
      this.$store.dispatch('LoaderStore/displayLoader')
      axios
        .patch(`/api/products/${this.$route.params.id}`, {
          product: this.product
        })
        .then(async () => {
          await this.updateProductImageAction()
          const payload = {
            status: 200,
            message: '保存に成功しました。'
          }
          await this.$store.dispatch(
            'SystemMessageStore/createMessage',
            payload
          )
          this.fetchProduct()
        })
        .catch((error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.message
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        })
        .finally(() => this.$store.dispatch('LoaderStore/hideLoader'))
    },
    updateProductImageAction () {
      return Promise.all(
        this.productImages.map(async (image, index) => {
          if (image.deleted && image.id) {
            return deleteImage(image.id)
          } else if (image.id) {
            return this.updateProductImage(image, image.altAttribute, index)
          } else if (!image.deleted) {
            return uploadImage(
              this.productId,
              image.file,
              image.url,
              image.altAttribute,
              index
            )
          }
        })
      )
    },
    updateProductImage (image, altAttribute, priority) {
      return new Promise((resolve, reject) =>
        updateImage(image.id, altAttribute, priority)
          .then((responce) => {
            resolve(responce)
          })
          .catch((error) => {
            reject(error)
          })
      )
    }
  }
}
</script>
